export type IkasPaymentGatewayAdditionalPrice = {
  amount: number;
  amountType: IkasPaymentGatewayTransactionFeeType;
  name: string;
  type: IkasPaymentGatewayAdditionalPriceType;
};

export enum IkasPaymentGatewayTransactionFeeType {
  AMOUNT = "AMOUNT",
  RATIO = "RATIO",
}

export enum IkasPaymentGatewayAdditionalPriceType {
  DECREMENT = "DECREMENT",
  INCREMENT = "INCREMENT",
}
